module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-200.55c2cae4.woff2";